export const TEXTS = {
  NEXT: 'Next',
  VIEW_BAG: 'View bag',
  ADD_TO_BAG: 'Add to Bag',
  ADDED_TO_CART: 'Item added to bag',
  ADD_TO_CART_ERROR: 'Something went wrong. Make it yours by trying once again!',
};

export const CUSTOMIZATION = {
  IS_MANDATORY: '2',
  IS_NON_MANDATORY: '1',
  IS_NOT_CUSTOMISABLE: '0',
};
